// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Outros */
export const Outros = createBankIcon({
  name: "Outros",
  slug: "outros",
  compe: null,
  color: "#9aa0a6",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#9aa0a6;fill-opacity:1\"\n     id=\"outros_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(50.01548,50.01548) scale(0.8286) translate(-50.01548,-50.01548) translate(-1.5,2.5)\">\n    <path\n       d=\"M 36,38\n          C 36,25 45,18 55,20\n          C 65,22 70,30 65,38\n          C 62,43 56,45 52,50\n          C 50,52 50,54 50,58\"\n       style=\"fill:none;stroke:#ffffff;stroke-width:11;stroke-linecap:round;stroke-linejoin:round\" />\n    <circle cx=\"50\" cy=\"74\" r=\"6\" style=\"fill:#ffffff\" />\n  </g>",
});
